import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Stack, TextField } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadHide, uploadSetContents, uploadSetFileName, uploadSetMachineStart, uploadSetMotorStop, uploadSetNote } from "../reducer/ScanUploadSlice";
import { CloudUpload } from "@mui/icons-material";
import { hideProcessing, showProcessing } from "../reducer/ProcessingSlice";
import api from "../common/api";
import { useAuth0 } from "@auth0/auth0-react";

export default function ScanUpload(props) {
    const { fileUploaded } = props;
    // const auth = useSelector(state => state.auth);
    const upload = useSelector(state => state.upload);
    const [error,setError] = useState("");
    const dispatch = useDispatch();
    const {getAccessTokenSilently} = useAuth0();
    let fileReader;

    const handleClose = () => {
        dispatch(uploadHide());
    }
    
    const getX = (line) => {
        let parts = line.replace('\r','').split('\t');
        // line is an array
        if(parts.length > 1) {
            return parts[0]; // x is the first element of the array
        } else {
            return -1;
        }
    }

    const handleFileRead = () => {
        const contents = fileReader.result;
        let lines = contents.split('\n');
        let start = -1;
        let stop = -1;
        
        for(let i=0;i<lines.length && start === -1; i++) {
            start = getX(lines[i])
        }
        
        for(let i=lines.length-1;i >=0 && stop === -1; i--) {
            stop = getX(lines[i]);
        }

        if(start !== -1) {
            dispatch(uploadSetMachineStart({machineStart: start}));
        }

        if(stop !== -1) {
            dispatch(uploadSetMotorStop({motorStop: stop}));
        }

        dispatch(uploadSetContents({contents: contents}));
    }

    const handleFileChosen = (file) => {
        setError("");
        dispatch(uploadSetFileName({fileName: file.name}));
        fileReader = new FileReader();
        fileReader.onloadend = handleFileRead;
        fileReader.readAsText(file);
    };

    const handleStartChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            dispatch(uploadSetMachineStart({machineStart: evt.target.value}));
        }
    }

    const handleStopChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            dispatch(uploadSetMotorStop({motorStop: evt.target.value}));
        }
    }

    const handleNote = (evt) => {
        dispatch(uploadSetNote({note: evt.target.value}));
    }

    const handleUploadClick = async () => {

        dispatch(showProcessing({message: "Uploading scan..."}));
        setError("");
        let token = await getAccessTokenSilently();
        new api().request(`scan/parse`, token, "post", {
            description: upload.note,
            data: upload.contents,
            machinestart: upload.machineStart,
            motorstop: upload.motorStop,
            distancetoff: 38000,
            distanceftor : 120000,
            auid: upload.auid
        })
        .then((data) => {
            if(fileUploaded) {
                fileUploaded();
            }
            handleClose();
        })
        .catch((err) => {
            console.log(err);
            setError(err.response.data);
        })
        .finally(() => {
            dispatch(hideProcessing());
        })
    }

    return (
        <Dialog
            open={upload.show}
            onClose={handleClose}
        >
            <DialogTitle>Upload Scan</DialogTitle>
            <DialogContent>
                <FormControl fullWidth sx={{paddingBottom: "5px"}}>
                    <Button
                        variant="contained"
                        component="label"
                    >
                        Select File
                        <input
                            type="file"
                            hidden
                            accept='.tsv'
                            onChange={e => handleFileChosen(e.target.files[0])}
                            value={""}
                        />
                    </Button>
                    <Box sx={{paddingTop: "5px"}}>
                        {(upload.fileName.length > 0 ) && <label>File: {upload.fileName}</label>}
                    </Box>
                </FormControl>
                <Stack direction="row" spacing={1}>
                    <TextField
                        required
                        label="Start"
                        variant="standard"
                        disabled={upload.fileName.length === 0}
                        value={(upload.machineStart !== -1) ? upload.machineStart : ""}
                        inputProps={{ inputMode: 'numeric', maxLength: 6}}
                        onChange={handleStartChange}
                        >
                    </TextField>
                    <TextField
                        required
                        label="Stop"
                        variant="standard"
                        value={(upload.motorStop !== -1) ? upload.motorStop : ""}
                        disabled={upload.fileName.length === 0}
                        inputProps={{ inputMode: 'numeric', maxLength: 6}}
                        onChange={handleStopChange}
                    >
                    </TextField>
                </Stack>
                <TextField
                    required
                    label="Note"
                    fullWidth
                    variant="standard"
                    disabled={upload.fileName.length === 0}
                    onChange={handleNote}
                    ></TextField>
                {(error.length >0 && <Box sx={{color:"red", paddingTop: "3px"}}>{error}</Box>)}
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    startIcon={<CloudUpload/>}
                    disabled={upload.fileName.length === 0 || upload.machineStart === -1 || upload.motorStop === -1 || upload.note.length === 0}
                    onClick={handleUploadClick}
                >Upload</Button>
                <Button
                    variant="outlined"
                    color="inherit"
                    onClick={handleClose}
                >Cancel</Button>
            </DialogActions>
        </Dialog>
    )

}